var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-bar',{attrs:{"title":"Meus Cartões"}}),(_vm.pagamento === '32')?_c('div',[_c('cartoes-mercadopago')],1):_vm._e(),(_vm.pagamento === '30')?_c('div',[_c('cartoes-pagarme')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }